/* API METHODS */



// Variables
const apiUrl = window.location.origin === 'http://localhost:3000' ?
	'https://mxvictoriaddm.dp150.xyz/' :
	`${window.location.origin}/`



/* GET */
export const get = (url:string, customUrl:boolean = false) => {
	return new Promise( resolve => {
    // fetch(`${apiUrl}${url}`, {
    fetch( customUrl ? url : `${apiUrl}${url}`, {
			method: 'GET',
			// headers: headers(),
			// mode: 'no-cors',
			// cache: 'default'
		})
			.then( res => {
				if( !res.ok ) throw res.status
				return res.json()
			})
			.then( data => {
				resolve( data )
			})
			.catch( error => console.log(error) )
	} )
}



/* POST */
export const post = (url:string, body:any, customUrl:boolean = false, isJson:boolean = true) => {
	return new Promise( resolve => {
		// fetch(`${apiUrl}${url}`, {
    fetch( customUrl ? url : `${apiUrl}${url}`, {
			method: 'POST',
			headers: headers(),
			body: isJson ? JSON.stringify(body) : body
		})
			.then( res => {
				if( !res.ok ) throw res.status
				return res.json()
			})
			.then( data => {
				resolve( data )
			})
			.catch( error => console.log(error) )
	} )
}



/* HEADERS */
function headers() {
	const headers = new Headers()
	// headers.append('Access-Control-Allow-Origin', '*')
	// headers.append('Content-Type', 'application/json')
	headers.append('Accept', '*/*')
	// headers.append('X-Requested-With', 'XMLHttpRequest')
	return headers
}
